import React from "react";

import { useFormikContext } from "formik";

import { Template } from "../../../../../models";

import SwitchContainer from "../../common/SwitchContainer";

export default function ImageExcludeFacesToggle() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();
  return (
    <SwitchContainer
      title="Attempt to exclude people and faces"
      enabled={values.excludeImageFaces || false}
      setEnabled={() => {
        setFieldValue("excludeImageFaces", !values?.excludeImageFaces);
      }}
    />
  );
}
